export default {
    buildMode: "prod",
    korotHomePageApiBaseUrl_US: "https://be-us.korot.com/",
    korotHomePageApiBaseUrl_KR: "https://be-kr.korot.com/",
    korotStorageApiBaseUrl_US: "https://korotstoragekr.blob.core.windows.net/",
    korotStorageApiBaseUrl_KR: "https://korotstoragekr.blob.core.windows.net/",
    korotAdminApiBaseUrl: "https://be-admin.korot.com/",
    naverLoginApiBaseUrl: "https://openapi.naver.com/",
};
